import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import SvgIcon from '@mui/material/SvgIcon';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { SettingsWrapper } from '../../../layout';
import { SettingsHeader } from './SettingsHeader';
import { useAppDispatch, useAppSelector } from '../../../hooks/useAppStore';
import { settingsActions } from '../../../store/settings/slice';
import { IntegrationNav } from './IntegrationNav';
import { useGetDorIntegrationAPI } from '../../../hooks/api/useIntegrations';
import { getDorIntegration } from '../../../store/settings/selectors';
import { ReactComponent as EditIcon } from '../../../static/icons/ic_edit.svg';
import { DorLocationsDialog } from './DorLocationsDialog';

const IntegrationSettings = () => {
  const dispatch = useAppDispatch();
  useGetDorIntegrationAPI();
  const { t } = useTranslation('settings');
  const dorIntegration = useAppSelector(getDorIntegration);

  const handleChipClick = () => {
    dispatch(settingsActions.setIsOpenIntegrationNav(true));
  };

  return (
    <SettingsWrapper>
      <SettingsHeader
        title={t('integrations')}
        subtitle={t('connectWithPayroll')}
      />
      <Divider sx={{ pt: 4, mr: 4, borderStyle: 'dashed' }} />
      <Grid
        sx={{ py: 4, paddingTop: { xs: 2 } }}
        spacing={2}
        columns={12}
        container
      >
        <Grid
          size={{
            lg: 4,
            md: 7,
            xs: 12,
            sm: 12,
          }}
        >
          <Card
            sx={{
              mt: 6,
              marginTop: { xs: 2 },
              borderRadius: 2,
              ':hover': {
                boxShadow: 'rgba(32, 40, 45, 0.08) 0px 2px 14px 0px',
              },
            }}
          >
            <CardHeader
              sx={{ p: 2 }}
              title={(
                <Stack spacing={2} direction="row" alignItems="center">
                  <Typography variant="h6">Dor</Typography>
                  <Avatar
                    src="/static/dor.png"
                    alt="Dor Logo"
                    sx={{ width: 40, height: 40 }}
                  />
                </Stack>
              )}
              action={(
                <Stack direction="row" alignItems="center" spacing={3}>
                  {dorIntegration?.apiKey && (
                    <Box onClick={handleChipClick}>
                      <SvgIcon
                        className="cursor-pointer"
                        component={EditIcon}
                        inheritViewBox
                      />
                    </Box>
                  )}
                  <Chip
                    sx={{
                      backgroundColor: dorIntegration?.apiKey ? '#10B981' : '#A855F7',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: dorIntegration?.apiKey ? '#10B981' : '#A855F7',
                        color: 'white',
                      },
                      '& .MuiChip-label': {
                        color: 'inherit',
                      },
                    }}
                    label={dorIntegration?.apiKey ? t('connected') : t('connect')}
                    {...(!dorIntegration?.apiKey && {
                      onClick: handleChipClick,
                    })}
                    style={{ margin: '4px' }}
                  />
                </Stack>
              )}
            />
            <CardContent>
              <Stack spacing={2} direction="column">
                <Typography variant="body2">
                  {t('seamlesslyIntegrate')}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <IntegrationNav />
      <DorLocationsDialog />
    </SettingsWrapper>
  );
};

export { IntegrationSettings };
